import { translate } from '../../../i18n/I18nProvider';
import { CSV_HEADERS } from '../../../consts/csvHeaders';
import STATUS_BOX_OPTIONS from '../../../consts/statusBoxOptions';
import Optional from '../../../utils/optional';
import fetchRangesPaginate from './fetchRangesPaginate';
import exportTableDataCsv from '../../../utils/exportTableDataCsv';

const exportNumberRangesCsv = async ({
  dataManager,
  client,
  getConnectRanges,
  clientName
}) => {
  return exportTableDataCsv({
    dataManager,
    fetchData: ({ query }) =>
      fetchRangesPaginate({ query, client, getConnectRanges }),
    csvHeaders: CSV_HEADERS.NUMBER_RANGES,
    filename: clientName
      ? `${translate('MENU.EXTERNAL_NUMBER')} - ${clientName}`
      : translate('MENU.EXTERNAL_NUMBER'),
    mapData: row => ({
      ...row,
      providerName: row.provider?.name,
      clientName: row.client?.name,
      platform: `${Optional(
        STATUS_BOX_OPTIONS.PLATFORM_OPTIONS?.[row.platform]?.text
      ).or('')}${
        row.isPlatfromFormRange ? ` - ${translate('FROM_CLIENT')}` : ''
      }`
    })
  });
};

export default exportNumberRangesCsv;
